export default [
    {
        name: 'floorColorTexture',
        type: 'texture',
        path: 'textures/narrow-floorboards/color.png'
    },
    {
        name: 'floorHeightTexture',
        type: 'texture',
        path: 'textures/narrow-floorboards/height.png'
    },
    {
        name: 'floorNormalTexture',
        type: 'texture',
        path: 'textures/narrow-floorboards/normal.png'
    },
    {
        name: 'floorAmbientOcclusionTexture',
        type: 'texture',
        path: 'textures/narrow-floorboards/ao.png'
    },
    {
        name: 'floorMetalnessTexture',
        type: 'texture',
        path: 'textures/narrow-floorboards/metallic.png'
    },
    {
        name: 'floorRoughnessTexture',
        type: 'texture',
        path: 'textures/narrow-floorboards/roughness.png'
    },
    {
        name: 'monitorBackgroundTexture',
        type: 'texture',
        path: 'textures/monitor_background.png'
    },
    {
        name: 'notebookBackgroundTexture',
        type: 'texture',
        path: 'textures/notebook_background.png'
    },
    {
        name: 'deskModel',
        type: 'gltfModel',
        path: 'models/desk.gltf'
    },
    {
        name: 'arcadeModel',
        type: 'gltfModel',
        path: 'models/arcade.gltf'
    },
    {
        name: 'doorModel',
        type: 'gltfModel',
        path: 'models/door.gltf'
    },
    {
        name: 'monitorModel',
        type: 'gltfModel',
        path: 'models/monitor.gltf'
    },
    {
        name: 'keyboardModel',
        type: 'gltfModel',
        path: 'models/keyboard.gltf'
    },
    {
        name: 'windowModel',
        type: 'gltfModel',
        path: 'models/window.gltf'
    },
    {
        name: 'plantModel',
        type: 'gltfModel',
        path: 'models/plant.gltf'
    },
    {
        name: 'pencilModel',
        type: 'gltfModel',
        path: 'models/pencil.gltf'
    },
    {
        name: 'notepadModel',
        type: 'gltfModel',
        path: 'models/notepad.gltf'
    },
    {
        name: 'notebookModel',
        type: 'gltfModel',
        path: 'models/notebook.gltf'
    },
    {
        name: 'mugModel',
        type: 'gltfModel',
        path: 'models/mug.gltf'
    },
    {
        name: 'mouseModel',
        type: 'gltfModel',
        path: 'models/mouse.gltf'
    },
    {
        name: 'lightswitchModel',
        type: 'gltfModel',
        path: 'models/lightswitch.gltf'
    },
    {
        name: 'lampModel',
        type: 'gltfModel',
        path: 'models/lamp.gltf'
    },

]
